import { UPDATE_LOADING_STATE } from "../actions/types";

const reducer = (state = true, action) => {
  switch (action.type) {
    case UPDATE_LOADING_STATE:
      return action.payload;
    default:
      return state;
  }
};

export default reducer;
